"use client";

export function PrintButton() {
  return (
    <button
      onClick={() => window.print()}
      className="text-body-lg text-inline-link mt-3 cursor-pointer text-black/50"
    >
      Print this page
    </button>
  );
}
